export default {"src":"/_next/static/media/Maximum.ff2b4dea.svg","height":16,"width":62};